import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../@types/RootState';

const initialState = 0;

const slice = createSlice({
  name: 'getFamilyModal/totalElements',
  initialState,
  reducers: {
    SET_GET_FAMILY_MODAL_TOTAL_ELEMENTS: (_state, { payload }: PayloadAction<number>) => payload,
  },
});

export const selectorGetFamilyModalTotalElements = (state: RootState) => {
  return state.getFamilyModalReducer.totalElements;
};

export const { SET_GET_FAMILY_MODAL_TOTAL_ELEMENTS } = slice.actions;

export default slice.reducer;
